export default __webpack_public_path__ + "static/media/ic_shopping-cart-2.e71d8a7a.svg";